import type { TabPanelProps } from '@vtex/admin-ui'
import { TabPanel, csx } from '@vtex/admin-ui'
import React from 'react'

type CustomTabContentBaseProps = {
  renderOnlyFocused?: boolean
}

export type CustomTabContentProps = CustomTabContentBaseProps & TabPanelProps

export const CustomTabContent = (props: CustomTabContentProps) => {
  const { renderOnlyFocused = true, children, state, ...tabProps } = props

  const returnChildren =
    !renderOnlyFocused || state.activeId === props.id ? children : null

  return (
    <TabPanel
      state={state}
      className={csx({
        flexDirection: 'column',
        overflow: 'auto',
        height: 'full',
        padding: 0,
      })}
      {...tabProps}
    >
      {returnChildren}
    </TabPanel>
  )
}
